// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___edfa69ffac4b43e5b48","cls2":"ImpactHubModal-cls2___045a9dec09d721bcd5e ImpactHubModal-cls1___edfa69ffac4b43e5b48"};